import S from './MenuSpacer.module.scss';
export const MenuSpacer = () => {
  return <hr className={S.spacer} data-sentry-component="MenuSpacer" data-sentry-source-file="MenuSpacer.tsx" />;
};